import { render, staticRenderFns } from "./StartTemplate.vue?vue&type=template&id=dfdf88ea"
import script from "./StartTemplate.vue?vue&type=script&lang=ts"
export * from "./StartTemplate.vue?vue&type=script&lang=ts"
import style0 from "./StartTemplate.vue?vue&type=style&index=0&id=dfdf88ea&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports